import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';

import ChatbotIntroResponse from '~chatbot/ui/ChatbotIntroResponse';
import chatbotImage from '~chatbot/assets/chatbot-character.webp';
import { useChatbotContext } from '~chatbot/context/ChatbotContext';
import styles from './ChatbotModal.module.scss';
import SystemResponse from '~chatbot/ui/SystemResponse';
import { handleTracking } from '~chatbot/utils/analytics';


function ChatbotModal({ extraClass, initialNote }) {
  const {
    chats, isFetching, getTimings, config,
  } = useChatbotContext();
  const showSuggestedOptions = Object.keys(chats).length === 0;

  const chatContainerRef = useRef(null);

  useEffect(() => {
    chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
  }, [chats, isFetching]);

  useEffect(() => {
    let timeout;
    if (isFetching) {
      timeout = setTimeout(() => {
        handleTracking({
          click_type: 'ai_bot_response_delay',
          click_text: `${isFetching}`,
        });
      }, 10000);
    }

    return () => clearTimeout(timeout);
  }, [isFetching]);


  return (
    <div
      className={classNames(
        styles.chatWindow,
        { [styles.extraClass]: !!extraClass },
      )}
      ref={chatContainerRef}
    >


      <ChatbotIntroResponse
        response={initialNote}
        showSuggestedOptions={showSuggestedOptions}
        externalTimingClass={styles.timings}
        externalResponseClass={styles.response}
        showRcbOption={config.showRcbOption}
      />


      {Object.keys(chats).map((chatkey) => {
        const chat = chats[chatkey];
        return (
          <React.Fragment key={chatkey}>
            {chat.owner === 'user' && (
              <div
                key={chatkey}
                className={classNames(
                  styles.response, styles.userResponse,
                  { [extraClass]: !!extraClass },
                )}
              >
                <div>{chat.message}</div>
                <div className={classNames(styles.timings, styles.userTimings)}>
                  {getTimings()}
                </div>
              </div>
            )}
            {chat.owner === 'system' && (
              <div
                key={chatkey}
                className={classNames(styles.systemResponse)}
              >
                <div>
                  <img
                    src={chatbotImage}
                    alt="chat"
                    className={classNames(styles.avatar)}
                  />
                </div>
                <SystemResponse
                  chat={chat}
                  externalResponseClass={styles.response}
                  externalTimingClass={styles.timings}
                  extraClass={extraClass}
                />
              </div>
            ) }
          </React.Fragment>
        );
      })}
      {isFetching && (
        <ChatbotIntroResponse
          response="Please wait.."
          showSuggestedOptions={false}
          externalResponseClass={styles.response}
          showTiming={false}
          showRcbOption={false}
        />
      ) }
    </div>
  );
}

export default ChatbotModal;
